import { createContext, useContext } from 'react';

export const DitherLoadingContext = createContext<Set<string> | null>(null);
export const useDitherLoading = () => useContext(DitherLoadingContext);
